<template>
    <Head>
        <title>{{ title }}</title>
        <meta name="description" :content="description">
    </Head>

    <div class="layout-container max-w-full bg-white">
        <TopBar :overlay="topBarOverlay"/>

        <main>
            <slot />
        </main>
        <Footer/>
    </div>
    <BaseCallback/>
    <CookieAccept/>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import TopBar from "@js/components/TopBar.vue";
import Footer from "@js/components/Footer.vue";
import BaseCallback from "@js/components/BaseCallback.vue";
import CookieAccept from "@js/components/CookieAccept.vue";

export default {
    name: 'Layout',
    components: {
        CookieAccept,
        BaseCallback,
        Footer,
        TopBar,
        Head,
    },
    props: {
        title: String,
        description: String,
        schemaLd: {
            type: Object,
            default: () => ({}),
        },
        topBarOverlay: {
            type: Boolean,
            default: true,
        },
    },
}
</script>

<style scoped lang="scss">
.layout-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    main {
        flex: 1;
    }
}
</style>
